var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolderIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 74,
    viewBox: "0 0 75 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2513_578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.2675 26.6927L57.511 25.3118L58.3001 29.451L51.0566 30.8318L50.2675 26.6927ZM49.9094 24.2515L52.6192 21.5902L55.3291 18.9288L53.8633 17.4281L52.3976 15.9273L49.6878 18.5887L46.978 21.25L48.4437 22.7508L49.9094 24.2515ZM51.6217 33.2335L50.8108 35.1682L50 37.1029L53.4989 38.5807L56.9978 40.0585L57.8086 38.1238L58.6194 36.189L55.1205 34.7113L51.6217 33.2335ZM42.306 24.3069L40.6569 15.6561C40.5109 14.8904 39.9628 14.2656 39.2128 14.044C38.4835 13.8184 37.6596 13.9969 37.1009 14.5538L26.7119 24.7488L23.1936 25.4195C18.6199 26.2914 15.6216 30.7021 16.4935 35.2759C17.0931 38.4216 19.3859 40.7728 22.2204 41.6909L28.9063 54.9365L32.6629 53.0407L27.0082 41.8291L29.8435 41.2886L43.2545 46.9465C43.6498 47.1071 44.0667 47.1563 44.4599 47.0813C44.791 47.0182 45.1064 46.8723 45.3852 46.6476C46.0011 46.1656 46.2809 45.383 46.1349 44.6173L44.4858 35.9665C46.7247 34.6603 48.0292 32.0524 47.5124 29.3412C46.9955 26.6301 44.8271 24.7057 42.2607 24.2941L42.306 24.3069Z",
    fill: "#1E90B9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2513_578",
    x: -8.30767,
    y: -10.123,
    width: 91.8243,
    height: 91.8243,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.39364
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.17141
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2513_578"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2513_578",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon2);
export default __webpack_public_path__ + "static/media/folder_icon2.d33ca1cfe9b07c841d5d9865af785621.svg";
export { ForwardRef as ReactComponent };